// import exterior from "../public/img/exterior.png";

export const sideMenu = [
   {
      icon: "img/exterior.png",
      title: "Exterior",
      id: "Exterior",
      items: [
         {
            title: "Ultra Fast - Display",
            cameraName: "Ultra_Thin_Bezel_Display_F14",
            id:"Ultra_Thin_Bezel_Display_F14",
            type:'exterior',
            content:[
               {
                  heading:'HIGH REFRESH RATE',
                  text:'Choose the QHD 165Hz display for the ultimate combination of resolution and refresh rate. But for speed, the FHD 144Hz display will secure that split-second advantage.'
               },
               {
                  heading:'VISUALLY STUNNING',
                  text:'Whether gaming or creating content, the Blade 14 features wide color space of up to 100% DCI-P3 on the QHD 14” display and 100% sRGB on the FHD model. Every Razer display is custom calibrated for true color accuracy.'
               }
            ]
         },
         {
            title: "Ultra Clarity - Webcam",
            cameraName: "FHD_Webcam_Closeup_F12",
            id:"FHD_Webcam_Closeup_F12",
            type:'exterior',

            content:[
               {
                  heading:'FHD IR WEB CAMERA',
                  text:'Ultra-clear, high resolution 1080P webcam.'
               },
               {
                  heading:'WINDOWS HELLO',
                  text:'Using facial recognition or a PIN, Windows Hello is a fast, secure, and password-less way to unlock your Windows devices.'
               },
               {
                  heading:'DUAL-ARRAY',
                  text:'Benefit from the microphones operating in tandem to enhance your audio.'
               }
            ]


         },
         {
            title: "Ultra Small - Mobility",
            cameraName: "Footprint_F16_New",
            id:"Footprint_F16_New",
            type:'exterior',

            content:[
               {
                  heading:'THE SMALLEST 14” GAMING LAPTOP*',
                  text:'With a 40% smaller volume than average 15” gaming laptops, the Razer Blade 14 provides a level of mobility that’s essential for those on the go.'
               },
              
            ]
         },
         {
            title: "Ultra Responsive - Keyboard",
            cameraName: "Keyboard_F13",
            id:"Keyboard_F13",
            type:'exterior',

            content:[
               {
                  heading:'ANTI-GHOSTING KEYBOARD',
                  text:'Every keypress is executed accurately with a 1.1mm actuation height and anti-ghosting technology.'
               },
               {
                  heading:'RAZER CHROMA™ RGB',
                  text:'Per-key lighting delivers personalization with over 16.8 million colors and various effects. Experience greater immersion as your keyboard reacts dynamically when playing your favorite Chroma-integrated games.'
               },
               {
                           heading:'MICROSOFT PRECISION GLASS TOUCHPAD',
                           text:'Get smooth and precise control, and use a range of gestures for expanded navigation on the large, clickable precision glass touchpad with Microsoft support.'
               }
            ]


         },
         {
            title: "Ultra Connectivity - Ports",
            cameraName: "Ultra_Connectivity_02_F14",
            id:"Ultra_Connectivity_02_F14",
            type:'exterior',

            content:[
               {
                  heading:'LOTS OF PORTS',
                  text:'The Razer Blade 14 is designed to support a vast range of devices and includes other essential features for top-tier functionality.'
               }
            ]


         },
         // {
         //    title: "Precision Glass Touchpad",
         //    cameraName: "Precision_Glass_Touchpad_F13",
         //    id:"Precision_Glass_Touchpad_F13",
         //    type:'exterior',

         //    content:[
         //       {
         //          heading:'MICROSOFT PRECISION GLASS TOUCHPAD',
         //          text:'Get smooth and precise control, and use a range of gestures for expanded navigation on the large, clickable precision glass touchpad with Microsoft support.'
         //       },
               
         //    ]


         // },
         {
            title: "CNC Aluminum Design",
            cameraName: "Precision_Glass_New_CNC_aluminium_F13",
            id:"Render_Cam_F60_Chasis",
            type:'exterior',
            content:[
               {
                  heading:'DURABLE ALUMINUM CHASSIS',
                  text:'Forged from CNC aluminum with an anodized finish, the sleek, durable Razer Blade 14 is built for travel.'
               },
              
            ]


         },
      ]
   },
   {
      icon: 'img/interior.png',
      title: "Exploded view",
      id: "Interior",
      items: [
         {
            title: "Next-Gen Vapor Cooling",
            cameraName: "Render_Cam_F60_Heat_Compound",
            id:"Render_Cam_F60_Heat_Compound",
            type:'interior',

            content:[
               {
                  heading:'VACUUM SEALED LIQUID',
                  text:'Liquid Vapor filled chamber allows heat to move quickly & freely for optimum efficiency.'
               },
               {
                  heading:'MORE COVERAGE',
                  text:'Large surface area covers CPU & GPU along with other heat generating components.'
               }
            ]


         },
         {
            title: "Performance",
            cameraName: "Render_Cam_F60_Processor",
            id:"Render_Cam_F60_Processor",
            type:'interior',

            content:[
               {
                  heading:'NVIDIA® GeForce RTX™',
                  text:'NVIDIA® GeForce RTX™ 30 Series Laptop GPU, built with Ampere—NVIDIA’s 2nd gen RTX architecture— unleashes life-like ray-traced graphics and cutting-edge AI features like NVIDIA DLSS. Max-Q Technologies harnesses the power of AI to make the Razer Blade 14 thinner, faster and more powerful.'
               },
               {
                  heading:'AMD RYZEN',
                  text:'The Razer Blade 14 uses the latest breakthrough 6nm processor technology, the AMD Ryzen™ 6900HX. It delivers incredible gaming performance, cooler operation and prolongs battery life.'
               }
            ]


         },
         {
            title: "Memory",
            cameraName: "Render_Cam_F60_RAM",
            id:"Render_Cam_F60_RAM",
            type:'interior',

            content:[
               {
                  heading:'FAST MEMORY',
                  text:'Fast DDR5 4800 MHz memory with 50% increased clock speed compared to prior gen.'
               },
               {
                  heading:'LOAD UP',
                  text:'1TB of storage for plenty of games, music, and more. Storage slot supports NVMe single sided SSD and is expandable up to 2TB SSD (M.2 2280)'
               },
               
            ]


         },
         {
            title: "Fans",
            cameraName: "Render_Cam_F60_Thermal",
            id:"Render_Cam_F60_Thermal",
            type:'interior',

            content:[
               {
                  heading:'MORE BLADES LESS NOISE',
                  text:'The 67 blades quietly move high volume air flow across the heat exchangers.'
               },
            
            ]


         },
         {
            title: "Exhaust Fins",
            cameraName: "Render_Cam_F60_Exhaust_Fins",
            id:"Render_Cam_F60_Exhaust_Fins",
            type:'interior',

            content:[
               {
                  heading:'EXHAUST FINS',
                  text:'Integrated directly are dual heat exchangers with 83 fins each. Each fin is incredibly thin at 0.075 mm.'
               },
              
            ]


         }, 
         {
            title: "Battery",
            cameraName: "Render_Cam_F60_Battery_1",
            id:"Render_Cam_F60_Battery",
            type:'interior',

            content:[
               {
                  heading:'LONG BATTERY LIFE',
                  text:'Pure performance, minimal downtime: the Razer Blade 14’s intelligent battery management delivers 11 hours of action.'
               },
               {
                  heading:'2-YEAR LIMITED BATTERY WARRANTY',
                  text:'2022 models now include a 2-year limited battery warranty for additional peace of mind.'
               },
            ]


         },       
      ]
   },
   {
      icon: 'img/skins.png',
      title: "Skins",
      id:'Skins',
      items: [
         {
            id:'3D_Honeycomb_Black',
            name:'3D Honeycomb Black',
            icon: "img/skins_bundle/3D_Honeycomb_Black.svg",
            type:'Skins',

         }, 
         {
            id:'Brushed_Metal_Black',
            name:'Brushed Metal Black',
            icon: "img/skins_bundle/Brushed_Metal_Black.svg",
            type:'Skins'
         }, 
         {
            id:'Carbon_Fiber_Black',
            name:'Carbon Fiber Black',
            icon: "img/skins_bundle/Carbon_Fiber_Black.svg",
            type:'Skins'
         }, 
         {
            id:'Geometric_Mercury',
            name:'Geometric Mercury',
            icon: "img/skins_bundle/Geometric_Mercury.svg",
            type:'Skins'
         }, 
         {
            id:'Geometric_Quartz',
            name:'Geometric Quartz',
            icon: "img/skins_bundle/Geometric_Quartz.svg",
            type:'Skins'
         }, 
         {
            id:'Hex_Camo_Green',
            name:'Hex Camo Green',
            icon: "img/skins_bundle/Hex_Camo_Green.svg",
            type:'Skins'
         }, 
         {
            id:'Large_Camo_Green',
            name:'Large Camo Green',
            icon: "img/skins_bundle/Large_Camo_Green.svg",
            type:'Skins'
         }, 
         {
            id:'Lenticular_Camo_Black',
            name:'Lenticular Camo Black',
            icon: "img/skins_bundle/Lenticular_Camo_Black.svg",
            type:'Skins'
         }, 
         {
            id:'Satin_Flip_Grey',
            name:'Satin Flip Grey',
            icon: "img/skins_bundle/Satin_Flip_Grey.svg",
            type:'Skins'
         }
      ]
   },
   {
      icon: 'img/ar.svg',
      title: "AR view",
      id:'btnXR',
      items: [
         {
            title: "CNC Aluminum Design",
           

         },
         
      ]
   },
  
];
